import { QueryKey, useQuery } from "@tanstack/react-query";
import { projectApi } from "../api/project";
import { queryClient } from "../../../shared/providers/QueryProvider";

export const useStages = ({ searchKey, portfolioId, isPinned, isCompleted, quickFilters, page, limit }: { searchKey: string, portfolioId: string | undefined, isPinned: boolean, isCompleted: boolean, quickFilters: { region: string[] | null, programme: string[] | null, site: string[] | null, workstream: string[] | null , 'worktype-group': string[] | null, projectYear: string[] | null, my_tasks: boolean, stakeholder: string[] | null }, page: number, limit: number , }) => {

    const { data, isLoading, isError, refetch } = useQuery({
        queryKey: ["project-listing-stages", searchKey, portfolioId, isPinned, isCompleted, quickFilters['region'], quickFilters['programme'], quickFilters['site'], quickFilters['workstream'],quickFilters['worktype-group'], quickFilters['projectYear'], page, limit, quickFilters['my_tasks'], quickFilters['stakeholder']] as QueryKey,
        queryFn: () => projectApi.fetchProjectStages({
            search_term: searchKey,
            portfolio_id: portfolioId,
            region_id: quickFilters["region"],
            programme_id: quickFilters["programme"],
            site_id: quickFilters["site"],
            workstream_id: quickFilters["workstream"],
            work_type_group_id: quickFilters["worktype-group"],
            project_year: quickFilters["projectYear"],
            assign_to_me: quickFilters.my_tasks,
            stakeholder_id: quickFilters.stakeholder,
            ...(isCompleted ? {} : { is_pinned: isPinned }),
            ...(isCompleted ? { status: 'completed' } : {}),
        }),
    });

    return {
        stagesData: data?.data || [],
        isLoading,
        isError,
        refetch,
        removeCache: () => { queryClient.removeQueries({ queryKey: ["project-listing-stages"] }); },
        removeCachePinned: () => { queryClient.removeQueries({ queryKey: ["project-listing-stages"] }); },
        removeCacheUnpinned: () => { queryClient.removeQueries({ queryKey: ["project-listing-stages"] }); }
    };

}